module.exports = __webpack_public_path__ + "img/logo_with_text_en.31546ff5.png";